// src/styles/styles.js

const styles = {
  gradientBackground: {
    // Add any additional styles if needed
  },
  titleText: {
    fontFamily: 'FjallaOne, sans-serif',
    fontSize: '34px',
    color: '#FDC669',
    textShadow: '2px 2px 1px #ED1A23',
    textAlign: 'center',
  },
  smallText: {
    fontFamily: 'FjallaOne, sans-serif',
    fontSize: '18px',
    color: '#FDC669',
    textShadow: '2px 2px 1px #ED1A23',
    textAlign: 'center',
  },
  lottieContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '20px',
  },
  headerLink: {
    fontFamily: 'FjallaOne, sans-serif',
    fontSize: '20px', // Slightly smaller than titleText for navigation links
    color: '#FDC669',
    textShadow: '1px 1px 1px #ED1A23', // Subtle shadow to match the theme
    textDecoration: 'none', // Remove underline from links
    transition: 'color 0.2s ease-in-out',
    paddingBottom: '2px', // Add space for the underline effect
    _hover: {
      color: '#ED1A23', // Hover effect to make links stand out
    },
  },
  activeLink: {
    color: '#ED1A23', // Active link color
    textDecoration: 'underline', // Adds an underline for the active link
    textShadow: 'none', // Optionally remove shadow to make it stand out
    fontWeight: 'bold', // Make active link bold
  },
  howItWorksContainer: {
    marginTop: '20px',
    padding: '16px',
    textAlign: 'left',
    maxWidth: '800px',
    background: '#1A1A1A',
    borderRadius: '10px',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
  },
  howItWorksTitle: {
    fontFamily: 'FjallaOne, sans-serif',
    fontSize: '26px',
    color: '#FDC669',
    textShadow: '2px 2px 1px #ED1A23',
    marginBottom: '16px',
    textAlign: 'center',
  },
  howItWorksDescription: {
    fontFamily: 'FjallaOne, sans-serif',
    fontSize: '18px',
    color: '#FDC669',
    textShadow: '2px 2px 1px #ED1A23',
    marginBottom: '16px',
  },
  howItWorksListItem: {
    fontFamily: 'FjallaOne, sans-serif',
    fontSize: '18px',
    color: '#FDC669',
    textShadow: '2px 2px 1px #ED1A23',
    marginBottom: '12px',
  },
};

export default styles;
